
$(document).ready(function(){
    setTimeout(function(){
        $('#product-grid .grid__item').each(function(){    
            if(Number($(this).find('#real_p').attr('rel')) > 80){
                $(this).find('.thumb_set_badge_wrap').append('<div class="thumb_badge_free"><span>FREE<strong>SHIPPING</strong></span></div>')
            }
        })    
    },500)

})